export default __webpack_public_path__ + "static/media/page_not_found.b64df213.png";